import React, { useState, useEffect } from 'react';
import { Constants } from '../../../Constants';
import { toast } from 'react-toastify';
import classes from './ImageUploader.module.css';
import { useAppContext, ContextConstants } from '../../../Context/AppContext';
import axios from 'axios';
import { Urls } from '../../../Urls';
import { STORAGE_ACCOUNT } from '../../../config/env.config';
import Transporter_alt from '../../../Content/images/transporter_logo.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ImageUploader = ({
  onUpload,
  fileId,
  transporterId,
  isContact = false,
  isEditable,
  imgClassName,
  containerClassName,
  imgAlt = Transporter_alt
}) => {
  const { dispatch } = useAppContext();
  const [srcUrl, setSrcUrl] = useState(imgAlt);

  useEffect(() => {
    if (fileId) {
      getImgSrc();
    } else {
      setSrcUrl(imgAlt);
    }
  }, [fileId]);

  const onLoaderStateChange = () =>
    dispatch({
      type: ContextConstants.ToggleLoaderState
    });

  const onChange = e => {
    const file = e.target.files[0];

    if (validateFile(file)) {
      onLoaderStateChange();
      if(isContact){
        getBlobWritableUrl(Constants.FileHandlerActions.Upload, `${transporterId}_${file.name}`, file)
        .then(r => {
          uploadToWritableUrl(r.data.url, file)
            .then(() => {
              onUpload(r.data.file_name);
              getImgSrc()
              onLoaderStateChange();
            })
            .catch(e => handleCatch(e, onLoaderStateChange));
        })
        .catch(e => handleCatch(e, onLoaderStateChange));
      } else{
        getBlobWritableUrl(Constants.FileHandlerActions.Upload, transporterId, file)
        .then(r => {
          uploadToWritableUrl(r.data.url, file)
            .then(() => {
              onUpload(r.data.file_name);
              getImgSrc()
              onLoaderStateChange();
            })
            .catch(e => handleCatch(e, onLoaderStateChange));
        })
        .catch(e => handleCatch(e, onLoaderStateChange));
      }
    } else {
      e.target.value = null;
    }
  };

  const getImgSrc = () => {
    if(!fileId) return null;

    getBlobDownloadUrl(Constants.FileHandlerActions.Download, fileId)
      .then(r => {
        if (r.data.url) {
          setSrcUrl(r.data.url);
        } else {
          setSrcUrl(imgAlt);
        }
      })
      .catch(e => handleCatch(e));
  };

  return (
    <>
      <label
        className={`${classes.container} ${
          isEditable ? classes.pointer : ''
          } ${containerClassName}`}
      >
        {isEditable ? (
          <FontAwesomeIcon
            icon={['far', 'edit']}
            className={classes['edit-icon']}
            title="Upload"
          />
        ) : null}

        <input
          disabled={!isEditable}
          type="file"
          accept="image/*"
          onChange={onChange}
          className={`${classes['s-input']}`}
        />
        {srcUrl && 
          <img
            src={srcUrl}
            onError={e => imageFallBack(e, imgAlt)}
            alt="transporter logo"
            className={`${classes.logo} ${imgClassName}`}
          />
        }
      </label>
    </>
  );
};

const getBlobWritableUrl = (action, id, file) => {
  return axios.post(Urls.lorriFileService, {
    action: action,
    fileName: id,
    accountName: STORAGE_ACCOUNT,
    containerName: 'public-container'
  })
};

const getBlobDownloadUrl = (action, id) => {
  return axios.post(Urls.lorriFileService, {
    action: action,
    fileName: id,
    accountName: STORAGE_ACCOUNT,
    containerName: 'public-container'
  })
};

const uploadToWritableUrl = (writableUrl, file) =>
  axios.put(writableUrl, file, {
    headers: {
      'x-ms-blob-type': 'blockblob',
      'x-ms-blob-content-type': file.type,
      'x-ms-blob-content-disposition': file.name
    }
  });

const validateFile = file => {
  if (
    file &&
    file.size &&
    file.size < Constants.FileUploadMaxSize * 1024 * 1024
  ) {
    return true;
  } else {
    toast.warn(`Please upload file below ${Constants.ImageUploadMaxSize} MB`);
    return false;
  }
};

const handleCatch = (e, onLoaderStateChange) => {
  console.log(e, "error in image upload");
  toast.error('Failed to proceed request');
  onLoaderStateChange && onLoaderStateChange();
};

const imageFallBack = (e, imgAlt) => {
  e.target.src = imgAlt;
};

export default ImageUploader;
